// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3hXQ5","load3":"Spinner_load3__3qOXv"};